import PinMapFill from 'assets/icons/pin-map-fill-small.svg';
import { ListedPropertyDetailMemberAuctionProperty } from 'domain/entities/PropertyEntity';
import moment from 'moment';
import { StreetView } from 'presentation/components/StreetView';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useNavigate } from 'react-router-dom';
import { COMMON } from 'utilities/constants/COMMON';
import { DATE_FORMAT } from 'utilities/constants/DATE';
import { commonHelpers } from 'utilities/helpers';
import { MapInfo } from '../../../CU-057-01/models/MapInfo';
import { ButtonGroup } from './ButtonGroup';
import { CURRENT_SITUATION } from 'infrastructure/config/CONSTANTS';

interface props {
    detailAssessment?: ListedPropertyDetailMemberAuctionProperty;
}

export const PropertyDescription = ({ detailAssessment }: props) => {
    const navigate = useNavigate();

    const openGoogleMap = (lat?: number, lng?: number) => {
        const mapInfo: MapInfo = {
            lat: lat ?? 0,
            lng: lng ?? 0,
            currentPage: window.location.href,
            address: detailAssessment?.residence ?? '',
            propertyName: detailAssessment?.name ?? '',
        };

        navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_057_01}`, {
            state: mapInfo,
        });
    };

    const Info = (props: {
        isBorderBottom?: boolean;
        gap?: number;
        marginRight?: number;
        label: string;
        value: any;
        width?: any;
    }) => {
        return (
            <section
                className={`pd-element ${
                    props.isBorderBottom === undefined || props.isBorderBottom === true
                        ? 'border-bottom-des'
                        : ''
                }`}
                style={{
                    marginRight: props.marginRight ?? 48,
                    width: props.width ?? '100%',
                    minHeight: 50,
                    height: 'fit-content',
                }}
            >
                <div className="label" style={{ marginRight: props.gap ?? 8, minWidth: 100 }}>
                    {props.label}
                </div>
                <div className="value" style={{ flexGrow: 100 }}>
                    {props.value}
                </div>
            </section>
        );
    };

    const Address = (props: { data: any }) => {
        return (
            <section
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
            >
                <div style={{wordBreak: 'break-all'}}>{props.data}</div>
                <div
                    className="button-style"
                    onClick={() => openGoogleMap(detailAssessment?.lat, detailAssessment?.lng)}
                >
                    <img alt="" src={PinMapFill} />
                </div>
            </section>
        );
    };

    return (
        <section style={{ marginTop: 32 }}>
            <div style={{ display: 'flex' }} className="border-bottom-des">
                <section style={{ width: 343, marginRight: 26 }}>
                    <Info
                        label="部屋番号"
                        value={
                            detailAssessment?.roomNumber
                                ? `${detailAssessment.roomNumber} 号室`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="所在地"
                        value={
                            <Address
                                data={
                                    detailAssessment?.residence
                                        ? `${detailAssessment.residence}`
                                        : COMMON.EMPTY
                                }
                            />
                        }
                        marginRight={0}
                    />
                    <Info
                        isBorderBottom={false}
                        label="交通"
                        value={
                            detailAssessment?.stationName1
                                ? `${detailAssessment.lineName1 ?? ''} ${detailAssessment?.stationName1 ? detailAssessment?.stationName1 + '駅' : ''}  徒歩 ${detailAssessment.footMin1} 分`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                </section>
                <section style={{ width: 245 }}>
                    <StreetView
                        containerStyle={{ width: '245px', height: '160px' }}
                        center={{
                            lat: detailAssessment?.lat ?? 0,
                            lng: detailAssessment?.lng ?? 0,
                        }}
                    />
                </section>
            </div>
            <div style={{ display: 'flex' }}>
                <section style={{ width: 320, marginRight: 48 }}>
                    <Info
                        label="専有面積"
                        value={
                            detailAssessment?.occupiedArea
                                ? `${Number(detailAssessment.occupiedArea).toLocaleString('en-US', { maximumFractionDigits: 2 })} m²`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="間取り"
                        value={
                            detailAssessment?.roomLayoutDiv
                                ? `${detailAssessment.roomLayoutDiv}`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="現況"
                        value={
                            detailAssessment?.presentCondDiv 
                                ? detailAssessment.presentCondDiv
                                : COMMON.EMPTY
                            }
                        marginRight={0}
                    />
                    <Info
                        label="家賃"
                        value={
                            detailAssessment?.rent
                                ? `${commonHelpers.formatNumberMoney(detailAssessment.rent)}円/月`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="共益費"
                        value={
                            detailAssessment?.rent
                                ? `${commonHelpers.formatNumberMoney(detailAssessment.commonServiceFee)}円/月`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="管理費"
                        value={
                            detailAssessment?.managementFee
                                ? `${commonHelpers.formatNumberMoney(detailAssessment.managementFee)}円/月`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="修繕積立金"
                        value={
                            detailAssessment?.renovationDeposit
                                ? `${commonHelpers.formatNumberMoney(detailAssessment.renovationDeposit)}円/月`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="その他費用"
                        value={
                            detailAssessment?.otherExpenses01 || detailAssessment?.otherExpenses01 === 0
                                ? `${commonHelpers.formatNumberMoney(detailAssessment.otherExpenses01)}円`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="その他費用備考"
                        value={
                            detailAssessment?.otherExpensesNote01
                                ? `${detailAssessment.otherExpensesNote01}`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="所在階数"
                        value={
                            // NOTE: 'occupiedFloor'は数値, 'floors'は文字列で「階」を含む
                            (detailAssessment?.occupiedFloor
                                ? `${detailAssessment.occupiedFloor}`
                                : COMMON.EMPTY) +
                            '階/' +
                            (detailAssessment?.floors ?? `${COMMON.EMPTY}階`)
                        }
                        marginRight={0}
                    />
                    <Info
                        label="構造"
                        value={
                            detailAssessment?.structureName
                                ? `${detailAssessment.structureName}`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="建物管理会社"
                        value={
                            detailAssessment?.realEstateMgmtCompany
                                ? `${detailAssessment.realEstateMgmtCompany}`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="施工会社"
                        value={
                            detailAssessment?.constructionCompany
                                ? `${detailAssessment.constructionCompany}`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                </section>
                <section style={{ width: 320 }}>
                    <Info
                        label="バルコニー面積"
                        value={
                            detailAssessment?.balconyArea
                                ? `${Number(detailAssessment.balconyArea).toLocaleString('en-US', { maximumFractionDigits: 2 })} m²`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                        gap={32}
                    />
                    <Info
                        label="採光面"
                        value={
                            detailAssessment?.glossySurface
                                ? `${detailAssessment.glossySurface}`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                        gap={32}
                    />
                    <Info label="" value={''} marginRight={0} gap={32} isBorderBottom={false} />
                    <Info label="" value={''} marginRight={0} gap={32} isBorderBottom={false} />
                    <Info label="" value={''} marginRight={0} gap={32} isBorderBottom={false} />
                    <Info label="" value={''} marginRight={0} gap={32} isBorderBottom={false} />
                    <Info label="" value={''} marginRight={0} gap={32} isBorderBottom={false} />
                    <Info label="" value={''} marginRight={0} gap={32} />
                    <Info
                        label="築年月"
                        value={
                            moment(detailAssessment?.builtAt, true).isValid()
                                ? moment(detailAssessment?.builtAt).format(DATE_FORMAT.FORMAT3)
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                        gap={32}
                    />
                    <Info
                        label="総戸数"
                        value={
                            detailAssessment?.numOfUnit
                                ? `${detailAssessment.numOfUnit}戸`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                        gap={32}
                    />
                    <Info
                        label="分譲会社"
                        value={
                            detailAssessment?.sellingCompany
                                ? `${detailAssessment.sellingCompany}`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                        gap={32}
                    />
                    <Info
                        label="管理形態"
                        value={detailAssessment?.managementTypeName ?? COMMON.EMPTY}
                        marginRight={0}
                        gap={32}
                    />
                </section>
            </div>
            <div style={{ width: '100%' }}>
                <Info
                    label="管理員の勤務形態"
                    value={detailAssessment?.workingTypeName ?? COMMON.EMPTY}
                    marginRight={0}
                />
            </div>
            <div className="border-bottom-des">
                <ButtonGroup detailAssessment={detailAssessment} />
            </div>
            <div style={{ display: 'flex' }}>
                <section style={{ width: 320, marginRight: 48 }}>
                    <Info
                        label="備考"
                        value={detailAssessment?.notes ? `${detailAssessment.notes}` : COMMON.EMPTY}
                        marginRight={0}
                    />
                    <Info
                        label="取引形態"
                        value={detailAssessment?.transactionType ?? '仲介'}
                        marginRight={0}
                    />
                    <Info
                        label="情報公開日"
                        value={commonHelpers.formatDate(
                            detailAssessment?.termStartDate,
                            DATE_FORMAT.FORMAT4,
                        )}
                        marginRight={0}
                    />
                </section>
                <section style={{ width: 320 }}>
                    <Info
                        label="土地権利"
                        value={
                            detailAssessment?.landUseName
                                ? `${detailAssessment.landUseName}`
                                : COMMON.EMPTY
                        }
                        marginRight={0}
                    />
                    <Info
                        label="引渡時期"
                        value={detailAssessment?.transactionDeliveryTime ?? '相談'}
                        marginRight={0}
                    />
                    <Info
                        label="次回更新予定日"
                        value={commonHelpers.formatDate(
                            detailAssessment?.termEndDate,
                            DATE_FORMAT.FORMAT4,
                        )}
                        marginRight={0}
                    />
                </section>
            </div>
            <div className="pd-title">取扱店舗</div>
            <section>
                <Info
                    label="広告主の名称"
                    value={
                        detailAssessment?.advertiserName
                            ? `${detailAssessment.advertiserName}`
                            : COMMON.EMPTY
                    }
                    marginRight={0}
                    isBorderBottom={false}
                />
                <Info
                    label="事業所所在地"
                    value={
                        detailAssessment?.officeAddress
                            ? `${detailAssessment.officeAddress}`
                            : COMMON.EMPTY
                    }
                    marginRight={0}
                    isBorderBottom={false}
                />
                <Info
                    label="電話番号"
                    value={
                        detailAssessment?.phoneNumber
                            ? `${detailAssessment.phoneNumber}`
                            : COMMON.EMPTY
                    }
                    marginRight={0}
                    isBorderBottom={false}
                />
                <Info
                    label="宅建免許証番号"
                    value={
                        detailAssessment?.licenseNumber
                            ? `${detailAssessment.licenseNumber}`
                            : COMMON.EMPTY
                    }
                    marginRight={0}
                    isBorderBottom={false}
                />
                <Info
                    label="加盟団体"
                    value={
                        detailAssessment?.storeAffiliatedOrganCode ? `${detailAssessment.storeAffiliatedOrganCode}` : COMMON.EMPTY
                    }
                    marginRight={0}
                    isBorderBottom={false}
                />
            </section>
        </section>
    );
};
